import styled from 'styled-components/macro';
import { Accordion, AccordionContainer } from '@yme/atoms/accordion';
import { ADAPTIVE } from '@yme/tokens/screen';
export const MobileWrapperStyled = styled.div `
  padding: 32px 0;
`;
export const SocialIconsStyled = styled.div `
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: end;
  flex-wrap: wrap;
  gap: 8px;

  ${ADAPTIVE.maxWidth.mobile} {
    justify-content: start;
    margin-top: 32px;
  }
`;
export const AccordionStyled = styled(Accordion) `
  ${AccordionContainer} {
    padding: 0;
  }
`;
